{
  "title": "Bienvenue sur Boomerang",
  "search": "Rechercher",
  "actions": {
    "recondition": "Reconditionner",
    "recycle": "Recycler",
    "newRepairFile": "Nouveau dossier de Réparation / Prise en charge"
  },
  "currentRepairFiles": {
    "title": "Dossier en cours",
    "subtitle": "Suivez vos dossiers de réparation en cours",
    "seeMore": "Voir plus",
    "table": {
      "reference": "Dossier",
      "company": "Nom de l'entreprise",
      "manufacturer": "Marque",
      "product": "Nom du produit",
      "status": "Statut",
      "time": "Temps",
      "modality": "Prise en charge"
    }
  },
  "kpi": {
    "title": "Gestion du parc",
    "teamUsage": "outils en cours d'utilisation",
    "seeMore": "Voir plus"
  },
  "footer": {
    "averageCustomer": ">85%",
    "averageResponse": " de devis automatiques",
    "guarantee": "Jusqu'à 6 mois de garantie Boomerang",
    "productLabel": "produits",
    "manufacturerLabel": "marques",
    "button": "Se former à Boomerang avec nos équipes"
  }
}
